module.exports = "/reports/directives/laborReportColumn-c977a8.html";